export enum ProposalNotificationType 
{
    ReturnedBack= 1,
    NewProposal = 2,
    InvestigatorResearchCenter = 3,
    Evaluator = 4,
    ReturnedBackFc = 5,
    NewAnnoucement = 6,
    ProjectInProgres =7,
    ProjectCancelled = 8,
    NewReport = 9,
    ReportAprove = 10,
    ReportEvaluator =11,
    FinalReport = 12,
    RequestFinalReport =13,
    ApprovedProposal =14,
    EvaluatorHasEvaluated = 15,
    AdminCenter = 16



}